import NavBar from "./NavBar";

const Footer = () => {
  return (
    <>
      <NavBar Header={false}/>
    </>
  );
}

export default Footer;